<script>
  import Select from 'svelte-select';
  import FilePreview from './FilePreview.svelte';
  import UploadFiles from './UploadFiles.svelte';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';
  import { client } from 'root/api/index.js';
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  import { onMount, getContext, onDestroy } from 'svelte';
  import { Modal } from 'bootstrap';
  import { createForm } from 'svelte-forms-lib';
  import FormInput from 'components/FormControls/FormInput.svelte';
  import FormTextarea from 'components/FormControls/FormTextarea.svelte';
  import Loader from './../components/Loader.svelte';
  import * as yup from 'yup';
  import EmailTagify from '../components/EmailTagify.svelte';
  let displayfiles = [];
  export const showModal = (taskId) => {
    // selectedToEmails=undefined;
    // selectedCCEmails=undefined;
    // selectedBCCEmails=undefined;
    selectedEmails = [];
    suggestedEmail = [];
    selectedCCEmails = [];
    suggestedCCEmail = [];
    selectedBCCEmails = [];
    suggestedBCCEmail = [];
    displayfiles = [];

    $form = { ...defaultValue };
    $form.taskId = taskId;
    $errors = {};
    fetchDetail(taskId);
    addTaskMailModal.show();
  };
  let selectedEmails = [];
  let suggestedEmail = [];
  let selectedCCEmails = [];
  let suggestedCCEmail = [];
  let selectedBCCEmails = [];
  let suggestedBCCEmail = [];

  //let selectedToEmails;
  //let selectedCCEmails;
  //let selectedBCCEmails;
  let formLoading = false;
  const fetchDetail = (taskId) => {
    formLoading = true;
    client.taskMailGet({ taskId }).then((response) => {
      formLoading = false;
      $form = response.data;
      if ($form.toEmails.length > 0) {
        //let arr=[];
        $form.toEmails.forEach((value, index) => {
          //  arr.push({id:index,name:value.email})
          selectedEmails.push(value.email);
          suggestedEmail.push(value.email);
        });
        //selectedToEmails=arr
      }
      if ($form.ccEmails.length > 0) {
        //let arr=[];
        $form.ccEmails.forEach((value, index) => {
          //arr.push({id:index,name:value.email})
          selectedCCEmails.push(value.email);
          suggestedCCEmail.push(value.email);
        });
        //selectedCCEmails=arr
      }
      if ($form.bccEmails.length > 0) {
        //let arr=[];
        $form.bccEmails.forEach((value, index) => {
          //arr.push({id:index,name:value.email})
          selectedBCCEmails.push(value.email);
          suggestedBCCEmail.push(value.email);
        });
        //selectedBCCEmails=arr
      }

      if ($form.attachments.length > 0) {
        displayfiles = $form.attachments;
      }
    });
  };

  const showDialog = getContext('showDialog');
  let addTaskMailModal;
  let isFormPending = false;
  let defaultValue = {
    taskId: 0,
    subject: '',
    content: '',
    toEmails: [],
    ccEmails: [],
    bccEmails: [],
    attachments: [],
  };
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      subject: yup.string().required('Subject is required'),
      content: yup.string().required('Email Body is required'),
      toEmails: yup
        .array()
        .required()
        .min(1, 'To Mail is required')
        .of(
          yup.object().shape({
            email: yup.string().email(),
          }),
        ),
      ccEmails: yup.array().of(
        yup.object().shape({
          email: yup.string().email(),
        }),
      ),
      bccEmails: yup.array().of(
        yup.object().shape({
          email: yup.string().email(),
        }),
      ),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .taskMailSend(values)
        .then((response) => {
          isFormPending = false;
          addTaskMailModal.hide();
        })
        .catch((err) => {
          isFormPending = false;
          showDialog({ message: [err.message] });
        });
    },
  });
  onMount(() => {
    addTaskMailModal = new Modal(document.getElementById('sendEmailModal'), {
      keyboard: false,
    });
  });
  // const complexItems = [
  // {value: 'chocolate', label: 'anis@nbnminds.com', name: 'sumit@nbnminds.com'},
  // ];
</script>

<!-- Modal -->

<div
  class="modal fade send-email-modal"
  id="sendEmailModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="sendEmailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Send Email
        </h5>
        <button
          type="button"
          class="btn-close btn-transparent border-0 shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height">
        {#if formLoading}
          <div class="d-flex align-items-center justify-content-center h-100">
            <Loader />
          </div>
        {:else}
          <div
            class="form-group mb-3 position-relative {$errors.toEmails && $errors.toEmails != ''
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="form-label">To Email</label
            >
            <EmailTagify
              selectedItems={selectedEmails}
              suggestedItems={suggestedEmail}
              onSelect={(items) => {
                let arr = [];
                items.forEach((element) => {
                  arr.push({ email: element.value });
                });
                $form.toEmails = arr;
                handleChange(customInputEvent(`toEmails`, arr));
              }}
            />
            <!-- <Select
					bind:selectedValue={selectedToEmails}
					items={complexItems}
					isMulti={true}
					isClearable={false}
					containerClasses="form-control"
					placeholder={"To Emails"}
					getSelectionLabel={(option) => {
					  return option.name;
					}}
					on:select={(ev)=>{
						if(ev.detail !== null &&$form.toEmails !=ev.detail){
							let arr=[]
							  ev.detail.forEach(element => {
								arr.push({"email":element.name})
							  });
							$form.toEmails=arr
							handleChange(customInputEvent(`toEmails`, arr));
						}
					}}
					name= "toEmails"
					optionIdentifier={"name"}
					getOptionLabel={(option) => {
					  return option.name;
					}}
				  /> -->
            {#if $errors.toEmails != undefined}
              <label class="formError">{$errors.toEmails}</label>
            {/if}
          </div>

          <div
            class="form-group mb-3 position-relative {$errors.ccEmails && $errors.ccEmails != ''
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="form-label">CC</label
            >
            <EmailTagify
              selectedItems={selectedCCEmails}
              suggestedItems={suggestedCCEmail}
              onSelect={(items) => {
                let arr = [];
                items.forEach((element) => {
                  arr.push({ email: element.value });
                });
                $form.ccEmails = arr;
                handleChange(customInputEvent(`ccEmails`, arr));
              }}
            />
            <!-- <Select
					bind:selectedValue={selectedCCEmails}
					items={complexItems}
					isMulti={true}
					isClearable={false}
					containerClasses="form-control"
					placeholder={"CC"}
					getSelectionLabel={(option) => {
					  return option.name;
					}}
					on:select={(ev)=>{
						if(ev.detail !== null && $form.ccEmails !=ev.detail){
						  let arr=[]
							  ev.detail.forEach(element => {
								arr.push({"email":element.name})
							  });
							$form.ccEmails=arr
							handleChange(customInputEvent(`ccEmails`, arr));
						}
					}}
					name= "ccEmails"
					optionIdentifier={"name"}
					getOptionLabel={(option) => {
					  return option.name;
					}}
				  /> -->
            {#if $errors.ccEmails != undefined}
              <label class="formError">{$errors.ccEmails}</label>
            {/if}
          </div>

          <div
            class="form-group mb-3 position-relative {$errors.bccEmails && $errors.bccEmails != ''
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="form-label">BCC</label
            >
            <EmailTagify
              selectedItems={selectedBCCEmails}
              suggestedItems={suggestedBCCEmail}
              onSelect={(items) => {
                let arr = [];
                items.forEach((element) => {
                  arr.push({ email: element.value });
                });
                $form.bccEmails = arr;
                handleChange(customInputEvent(`bccEmails`, arr));
              }}
            />
            <!-- <Select
					bind:selectedValue={selectedBCCEmails}
					items={complexItems}
					isMulti={true}
					isClearable={false}
					containerClasses="form-control"
					placeholder={"BCC"}
					getSelectionLabel={(option) => {
					  return option.name;
					}}
					on:select={(ev)=>{
						if(ev.detail !== null && $form.ccEmails !=ev.detail){
						  let arr=[]
							  ev.detail.forEach(element => {
								arr.push({"email":element.name})
							  });
							$form.bccEmails=arr
							handleChange(customInputEvent(`bccEmails`, arr));
						}
					}}
					name= "bccEmails"
					optionIdentifier={"name"}
					getOptionLabel={(option) => {
					  return option.name;
					}}
				  /> -->
            {#if $errors.bccEmails != undefined}
              <label class="formError">{$errors.bccEmails}</label>
            {/if}
          </div>

          <div class="form-group mb-3">
            <FormInput
              name="subject"
              label="Subject"
              type="text"
              placeholder="Enter Subject"
              error={$errors.subject}
              bind:value={$form.subject}
              handleChange={handleChange}
            />
          </div>

          <div class="form-group mb-3">
            <FormTextarea
              Style="height:320px; resize: auto;"
              name="content"
              label="Email Body"
              rows="10"
              placeholder="Enter Message"
              handleChange={handleChange}
              error={$errors.content}
              bind:value={$form.content}
            />
          </div>

          <div class="form-group mb-3">
            <!-- <UploadFiles/> -->
            <SimpleFileUploader
              requestFrom="taskEmailAttachment"
              on:fileChanged={(event) => {
                if (event.detail.type == 'add') {
                  $form.attachments.push(event.detail);
                } else if (event.detail.type == 'delete') {
                  let index = searchKeyByValue(
                    $form.attachments,
                    'fileName',
                    event.detail.fileName,
                  );
                  if (index !== -1) {
                    $form.attachments.splice(index, 1);
                  }
                } else if (event.detail.type == 'uploading') {
                  isFormPending = true;
                } else if (event.detail.type == 'uploaded') {
                  isFormPending = false;
                }
              }}
              photoUrl={displayfiles}
              allFileType={true}
              allowMultiple={true}
              entityId={$form.id}
            />
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          class="btn btn-primary m-0 px-4 font-size-12"
          on:click={handleSubmit}
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}
            Send
          {/if}
        </button>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }

  .send-email-modal {
    min-width: 500px;
    max-width: 100%;
  }
</style>
